class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.initSlideshowSlick();
  }

  initSlideshowSlick(){
    const slideshow = this.querySelector('.slideshow');

    const prev_arrow = $(this).find('.slick-prev-custom');
    const next_arrow = $(this).find('.slick-next-custom');

    const slick_options = {
      dots: this.dataset.dots == 'true' ? true : false,
      arrows: this.dataset.arrows == 'true' ? true : false,
      prevArrow: prev_arrow,
      nextArrow: next_arrow,
      infinite: false,
      slidesToShow: parseInt(this.dataset.slidesToShow),
      slidesToScroll: parseInt(this.dataset.slidesToScroll),
      autoplay: this.dataset.autoplay == 'true' ? true : false,
      autoplaySpeed: this.dataset.speed
   };

   console.log(slick_options);

    $(slideshow).slick(slick_options);

    $(prev_arrow).hide();

    $(slideshow).on('afterChange', function(event, slick, currentSlide) {
        if (currentSlide === 0) {
          $(prev_arrow).fadeOut('fast');
          $(next_arrow).fadeIn('fast');
        }
        else {
        	$(prev_arrow).fadeIn('fast');
        }

        if ($(slick.$slides[slick.$slides.length - 3]).hasClass('slick-current')) {
        	$(next_arrow).fadeOut('fast');
        } else {
          $(next_arrow).fadeIn('fast');
        }
      });

  }
}

customElements.define('announcement-bar', AnnouncementBar);
